import Grid from '@mui/material/Grid';

import { CardPostalElement } from 'payments/components/CardElements';
import { CloverCardField } from 'payments/components/CardField';
import { CommerceHubPostalCodeElement } from 'payments/components/commerceHub/CommerceHubPostalCodeElement';
import { PaymentFieldTypes } from 'payments/constants/card';
import { useCardFields } from 'payments/hooks/useCardFields';
import { type CardFieldStates } from 'payments/types/card';

interface CardFieldsContainerProps {
  cardFieldStates?: CardFieldStates;
}

export const CardFieldsContainer = ({
  cardFieldStates
}: CardFieldsContainerProps) => {
  const {
    CardField,
    NumberElement,
    ExpiryElement,
    CvcElement,
    isClover,
    isCommerceHub,
    isStripe
  } = useCardFields();

  /* istanbul ignore next */
  if (!CardField || !NumberElement || !CvcElement || !ExpiryElement) {
    return null;
  }

  return (
    <Grid container gap="16px" mb="32px">
      <Grid item xs>
        <CardField
          label="Card Number"
          name={PaymentFieldTypes.CARD_NUMBER}
          inputEl={NumberElement}
          fieldState={cardFieldStates?.cardNumber}
        />
      </Grid>
      <Grid item container direction="row" spacing={2}>
        <Grid item xs>
          <CardField
            label="MM/YY"
            name={PaymentFieldTypes.EXPIRATION_DATE}
            inputEl={ExpiryElement}
            fieldState={cardFieldStates?.expirationDate}
          />
        </Grid>
        <Grid item xs>
          <CardField
            label={isStripe ? 'CVC' : 'CVV'}
            name={PaymentFieldTypes.CVC}
            inputEl={CvcElement}
            fieldState={cardFieldStates?.cvv}
          />
        </Grid>
        {isClover && cardFieldStates?.zip && (
          <Grid item xs>
            <CloverCardField
              label="Zip"
              name={PaymentFieldTypes.ZIP_CODE}
              inputEl={CardPostalElement}
              fieldState={cardFieldStates.zip}
            />
          </Grid>
        )}
        {isCommerceHub && (
          <Grid item xs>
            <CommerceHubPostalCodeElement />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
